<div>
    <router-outlet>
    </router-outlet>
    <a class="btn btn-lg btn-dark" id="top" (click)="back_to_top()">
        <i class="fas fa-arrow-circle-up fa-lg"></i></a>
    <app-footer></app-footer>
</div>